import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { canUseDOM } from './utils';

export interface PortalProps {
  children: React.ReactNode;
  node?: Element | null;
}

const Portal = ({ children, node }: PortalProps) => {
  const defaultNodeRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return () => {
      if (defaultNodeRef.current) {
        document.body.removeChild(defaultNodeRef.current);
        defaultNodeRef.current = null;
      }
    };
  }, []);

  if (!canUseDOM) {
    return null;
  }

  if (!node && !defaultNodeRef.current) {
    defaultNodeRef.current = document.createElement('div');
    document.body.appendChild(defaultNodeRef.current);
  }

  return ReactDOM.createPortal(children, node || defaultNodeRef.current!);
};

export default Portal;
